module.exports = __webpack_public_path__ + "img/20210621_072109.b5370926.jpg";